<template>
  <div
    class="good-item"
    @click="showDetail()"
  >
    <div class="good-item-flex">
      <div class="good-img">
        <img :src="good.pict_url" />
      </div>
      <div class="good-info">
        <div class="title">{{ good.title }}</div>
        <div class="coupon-info">
          <div class="item">券￥{{ good.coupon_amount }}</div>
          <div class="item">已售{{ good.volume }}件</div>
        </div>
        <div class="price-content">
          <div class="price">
            劵后￥{{ price }}
            <!-- 商品价 zk_final_price  -->
          </div>
          <div class="original-price">￥{{ good.zk_final_price }}</div>
          <!-- 商品原价 reserve_price  -->
        </div>
        <div class="btn" v-if="$store.state.platform==1" @click.stop="goBuy(good.coupon_share_url)">
          <!-- 赚￥{{ promotion_rate }} -->
          前往购买
        </div>
        <div class="btn" v-else @click.stop="doCopy(good)">
          <!-- 赚￥{{ promotion_rate }} -->
          前往购买
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    good: Object,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["rate"]),
    // 券后价
    price(){
       return Number((this.good.zk_final_price - this.good.coupon_amount).toFixed(2));
    },
    // 佣金
    promotion_rate() {
      return (
        ((Number(this.good.commission_rate) / 1000) *
          this.price *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  methods: {
    // 查看商品详情
    showDetail(){
      const id=this.good.num_iid?this.good.num_iid:this.good.item_id
      window.localStorage.setItem('goodInfo',JSON.stringify(this.good))
      this.$router.push('/taobao/detail?id='+id);
    },
   // pc端领券购买
    goBuy(url) {
      window.open(url);
    },
    // 复制淘口令
    doCopy(item) {
      let url = "https:" + item.coupon_share_url;
      if (item.coupon_share_url == undefined) {
        url = item.coupon_click_url;
      }
      this.Post(
        {
          text: item.title,
          url: url,
          logo: item.pict_url
        },
        "/taobao/createTpwd",
        res => {
          if (res.states == 1) {
            let model = res.data.data.model;
            this.$router.push("/taobao/share?code=" + model);
          }
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.good-item {
  padding: 5px 10px;
  .good-item-flex {
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    position: relative;
    .good-img {
      width: 96px;
      img {
        width: 96px;
        border-radius: 10px 0 0 10px;
      }
    }
    .good-info {
      flex: 1;
      padding: 5px 8px;
      .title {
        color: #000;
      }
      .coupon-info {
        display: flex;
        padding: 4px 0;
        .item {
          border-radius: 4px;
          padding: 0 6px;
          font-size: 10px;
          border: 1px solid #ee0a24;
          color: #ee0a24;
          margin-right: 4px;
        }
      }
      .price-content {
        .price {
          color: #ee0a24;
        }
        .original-price {
          font-size: 10px;
          color: #999;
          text-decoration: line-through;
        }
      }
      .btn {
        position: absolute;
        padding: 0 15px;
        background: #ee730a;
        color: #ffffff;
        font-size: 14px;
        border-radius: 16px 0 0 16px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        right: 0;
        bottom: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/taobao/good.vue